import { render, staticRenderFns } from "./AnotacoesCadastro.vue?vue&type=template&id=c3f35100&scoped=true&"
import script from "./AnotacoesCadastro.vue?vue&type=script&lang=js&"
export * from "./AnotacoesCadastro.vue?vue&type=script&lang=js&"
import style0 from "./AnotacoesCadastro.vue?vue&type=style&index=0&id=c3f35100&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f35100",
  null
  
)

export default component.exports